import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';
import DeleteTotalExpensesCategory from './DeleteTotalExpensesCategory';

function AddTotalExpensesCategory({type, categoryName, categoryId, sum}) {

    const appState = useContext(StateContext)

    const [year, setYear] = useState(2020)
    const [totalExpense, setTotalExpense] = useState();

    const [newSum, setNewSum] = useState(sum)
    const [newCategoryName, setNewCategoryName] = useState(categoryName)

    useEffect(() => {

        try {
            const totalExpenseRef = firestore.collection("users").doc(appState.userId).collection("total-budget-categories");
            totalExpenseRef.where("category_id", "==", categoryId).onSnapshot(({docs}) => {
                const expenses = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                if (expenses.length > 0) {
                    setTotalExpense(expenses[0]);
                }   
            })

        } catch (error) {
            
        }

    }, [])

    async function addExpenseHandler(e) {

        e.preventDefault();
        try {
            const totalExpenseRef = firestore.collection("users").doc(appState.userId).collection("total-budget-categories");
            const data = {
                category: categoryName,
                category_id: categoryId,
                sum: sum,
                type: type,
                year: year
            }
            totalExpenseRef.add(data);
        } catch (error) {
            console.log(error);
        }

    }

    return (
        <React.Fragment>
            {totalExpense ? (
                <div className="row mt-4">
                    <div className="col-md-6">
                        Budsjett for kategori lagret:
                    </div>
                    <div className="col-md-6">
                        <span className="float-right">{totalExpense.sum}  <DeleteTotalExpensesCategory id={totalExpense.id} setTotalExpense={setTotalExpense} /></span>
                    </div>
                      
                </div>
            )
            : 
                <form onSubmit={addExpenseHandler}>

                    <label>Kategori</label>
                    <input className="form-control mb-2" value={newCategoryName} onChange={e => setNewCategoryName(e.target.value)} />
                    <label>Sum</label>
                    <input className="form-control mb-2" value={newSum} onChange={e => setNewSum(e.target.value)} type="number" />
                    <label>Year</label>
                    <input className="form-control mb-2" value={year} onChange={e => setYear(e.target.value)} />

                    <button className="btn btn-success btn-block">Legg til </button>
                </form>    
            }
        </React.Fragment>
    )
}
export default AddTotalExpensesCategory